import {Utils} from "../../../model/Utils";

export class BankTypeEmployee {
  id: number;
  bankTypeId:                 number;
  employeeId:                 string;
  timeInBankInMinutes:        number;
  oneDayInMinutes:            number;
  hourlyWage:                 number;
  useNormalEmployeeRate:      boolean;
  periodStartDt:              Date;
  periodEndDt:                Date;
  active:                     boolean;

  lastUpdateDt: Date;

  bankTypeName: string;


  public inRightPeriod(dtRef: Date):boolean{
      if (Utils.isNullOrUndefined(this.periodStartDt) || Utils.isNullOrUndefined(this.periodEndDt) || Utils.isNullOrUndefined(dtRef)){
        return this.active;
      }
      if (Utils.isAfterRefDate(dtRef,this.periodStartDt)){
        if (Utils.isBeforeRefDate(dtRef,this.periodEndDt)){
          return this.active;
        }
      }
      return false;
  }

  public static select( from: BankTypeEmployee[], bankId:number, refDt: Date):BankTypeEmployee{
    let all = new Array<BankTypeEmployee>();

    for (const bean of from){
      if (bankId === bean.bankTypeId){
        if (bean.inRightPeriod(refDt)){
          all.push(bean);
        }
      }
    }
    if (all.length===1){
      return all[0];
    }
    return null;
  }


}
